import { createEntity } from './api';

type Log = {
  level: string;
  message: string;
  browser: string;
  platform: string | undefined;
  userAgent: string;
  uri: string;
  buildVersion: string;
};

export const logApi = {
  post: createEntity<Log>('log'),
};
